import {motion} from "framer-motion";
import {FoodCategory} from "../../../types";

const CategoryButton = ({
                            category,
                            filter,
                            setFilter,
                        }: {
    category: FoodCategory;
    filter: string;
    setFilter: any;
}) => {
    return (
        <motion.div
            onClick={() => setFilter(category.urlParam)}
            whileHover={{scale: 1.1}}
            whileTap={{scale: 1.1}}
            className={`group ${
                category.urlParam === filter
                    ? "hover:bg-btnOverlay bg-cartNumBg"
                    : "bg-btnOverlay hover:bg-cartNumBg"
            } flex-shrink-0 min-w-[10rem] h-12 cursor-pointer rounded-lg drop-shadow-xl flex flex-col gap-3 items-center justify-center duration-150 transition-all ease-out`}
        >
            <p
                className={`px-2 text-base ${
                    category.urlParam === filter
                        ? "group-hover:text-textColor text-white text-center"
                        : "text-textColor group-hover:text-white text-center"
                } `}
            >
                {category.name}
            </p>
        </motion.div>
    );
};

export default CategoryButton;
